import { useNavigate } from 'react-router';
import { SeasonWeekModel } from '../../../../../model/season-week.model';
import {
  dateAndTimeFormatter,
  timeFormatter,
  timeZoneTimeFormatter,
} from '../../../../../utils/dateFormatter';
import { MatchSection } from './match-schedule-view';
import { getTypeOfMatchFormat } from '../../../../../utils/utils';
import { SkillSyncRegistrationWindow } from '../../../../../utils/constants';

interface SkillSyncWeekScheduleViewProps {
  seasonWeekModel: SeasonWeekModel;
}
const SkillSyncWeekScheduleView = ({ seasonWeekModel }: SkillSyncWeekScheduleViewProps) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className='flex  items-center gap-x-5 flex-wrap  border rounded-xl justify-between hover:cursor-pointer hover:bg-gray-100
	
				'
        onClick={(e) => {
          e.preventDefault();
          navigate(`/seasons/view/${seasonWeekModel?.seasonId}?week=${seasonWeekModel?.id}`);
        }}
      >
        {' '}
        <div className='flex justify-between items-center p-2 '>
          <div className='flex-col text-sm'>
            <p className='whitespace-nowrap'>
              Registration Opens:{' '}
              {timeZoneTimeFormatter(
                new Date(
                  new Date(seasonWeekModel.start_time ?? '').getTime() -
                    SkillSyncRegistrationWindow.timeInMilliseconds,
                ).toISOString(),
              )}
            </p>
            <p className='whitespace-nowrap'>
              Matches Start: {timeZoneTimeFormatter(seasonWeekModel.start_time ?? '')}
            </p>
          </div>
          <div className='border-r-2 p-2 mx-4 border-gray-800'></div>
          <div className='p-2 text-xs font-semibold'>
            <p>
              {getTypeOfMatchFormat({
                MatchFormat: {
                  id: seasonWeekModel.match_format_id ?? 0,
                  type: seasonWeekModel.match_format_type,
                  value: seasonWeekModel.match_format_value,
                  name: seasonWeekModel.match_format_name ?? '',
                },
              })}
            </p>
          </div>
        </div>
        <div className='flex flex-grow justify-center p-2'>
          {seasonWeekModel?.start_time &&
          new Date(seasonWeekModel.start_time).getTime() - Date.now() <=
            SkillSyncRegistrationWindow.timeInMilliseconds &&
          Date.now() <= new Date(seasonWeekModel.start_time).getTime() ? (
            <div className='flex justify-center btn bg-fen-red text-white text-center w-full m-auto'>
              Register Now!
            </div>
          ) : (
            <div className='flex justify-center btn border-2 text-center w-full m-auto'>
              Registration Opens at{' '}
              {timeFormatter(
                new Date(
                  new Date(seasonWeekModel.start_time ?? '').getTime() -
                    SkillSyncRegistrationWindow.timeInMilliseconds,
                ).toISOString(),
              )}
              !
            </div>
          )}
        </div>
        <div
          className=' w-[250px]'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div className='flex flex-col gap-2 p-2'>
            <MatchSection
              eventType='Season'
              image={seasonWeekModel.seasonImage!}
              name={
                seasonWeekModel.seasonName!.length >= 10
                  ? seasonWeekModel.seasonName?.slice(0, 10) + '...'
                  : seasonWeekModel.seasonName!
              }
              game={seasonWeekModel.gameName!}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SkillSyncWeekScheduleView;
